import {sharedCommonActions} from 'library/src/common/redux/SharedCommonActions';
import {getErrorMessage, logger} from 'library/src/core/services/LogService';
import {OrganisationsModel} from 'library/src/organisations/models/OrganisationsModel';
import {all, call, put, takeEvery} from 'redux-saga/effects';
import pixagriOrganisationsApiService from '../services/PixagriOrganisationsApiService';
import {
  GET_ORGANISATIONS,
  sharedOrganisationActions,
} from './SharedOrganisationsActions';

export default function* sharedOrganisationSagas() {
  yield all([takeEvery(GET_ORGANISATIONS, getAllowedOrganisationSaga)]);
}

function* getAllowedOrganisationSaga() {
  try {
    yield put(sharedCommonActions.fetchStart('getOrganizationSaga'));
    const allowedOrganisations: OrganisationsModel[] = yield call(
      pixagriOrganisationsApiService.getAllowedOrganisations.bind(
        pixagriOrganisationsApiService,
      ),
    );
    yield put(
      sharedOrganisationActions.getAllowedOrganisationsSuccess(
        allowedOrganisations,
      ),
    );
    yield put(sharedCommonActions.fetchSuccess('getOrganizationSaga'));
  } catch (error) {
    const message = getErrorMessage(error);
    logger.error(message);
    yield put(sharedCommonActions.fetchError('getOrganizationSaga', message));
  }
}
